module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA2.9d6e864d.jpg";